export default "__VITE_ASSET__DKfbSCRS__"